import { render, staticRenderFns } from "./imageViewCom.vue?vue&type=template&id=65799ba0&scoped=true&"
import script from "./imageViewCom.vue?vue&type=script&lang=ts&"
export * from "./imageViewCom.vue?vue&type=script&lang=ts&"
import style0 from "./imageViewCom.vue?vue&type=style&index=0&id=65799ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65799ba0",
  null
  
)

export default component.exports